import { useMutation } from "@tanstack/react-query";

import { useCustomerService } from "contexts/ServiceContext";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";

const useResendInvite = () => {
  const customerService = useCustomerService();
  const selectedCustomerCode = useSelectedCustomerCode()[0];

  return useMutation({
    mutationKey: ["resend-invite", { customer: selectedCustomerCode }],
    mutationFn: (userId: string) =>
      selectedCustomerCode
        ? customerService.resendInvite(userId, selectedCustomerCode)
        : Promise.reject("Missing customer code"),
  });
};

export default useResendInvite;
